let navigateRef = null;

export const setNavigate = (navigate) => {
  navigateRef = navigate;
};

export const navigateTo = (...args) => {
  if (navigateRef) {
    navigateRef(...args);
  }
};

export default navigateTo;





